<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <div class="table-top-box">
        <span class="fl left">{{ $t('label.exhibition.detail.title') }}</span>
        <span class="fr right" @click="$router.back()">
          <Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />{{
            $t('buttons.back')
          }}
        </span>
      </div>
      <Spin v-if="loading" fix />
      <div v-else>
        <h3 class="cp-title">{{ info.title | filterEmpty }}</h3>
        <description>
          <description-item
            :label="$t('label.exhibition.detail.exhibitionName')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.title | filterEmpty"
          />
          <description-item
            :label="$t('label.country')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.country | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.detail.city')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.city | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.detail.industry')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.industry | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.detail.relatedField')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.relatedFields | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.detail.audience')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.audience | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.holdCycle')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="info.holdCycle | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.detail.holdDate')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="holdDateText | filterEmpty"
          />
          <description-item
            :label="$t('label.exhibition.detail.nextHoldDate')"
            :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
            :value="nextHoldDateText | filterEmpty"
          />
        </description>

        <div class="pbr-title mt15 mb15">{{ $t('label.exhibition.detail.venueInfo') }}</div>
        <description>
          <template v-if="venueList.length">
            <template v-for="(venue, index) in venueList">
              <description-item
                :key="'venue-name-' + index"
                :label="$t('label.exhibition.detail.venueName')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="venue.venueName | filterEmpty"
              />
              <description-item
                :key="'venue-addr-' + index"
                :label="$t('label.exhibition.detail.venueAddress')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="venue.venueAddress | filterEmpty"
              />
              <description-item
                :key="'venue-contact-' + index"
                :label="$t('label.exhibition.detail.venueContact')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="venue.venueContacts | filterEmpty"
              />
            </template>
          </template>
          <description-item
            v-else
            :label="$t('label.exhibition.detail.venueName')"
            :span="24"
            value="--"
          />
        </description>

        <div class="pbr-title mt15 mb15">{{ $t('label.exhibition.detail.organizerInfo') }}</div>

        <description>
          <template v-if="organizerList.length">
            <template v-for="(organizer, index) in organizerList">
              <description-item
                :key="'org-name-' + index"
                :label="$t('label.exhibition.detail.organizerName')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="organizer.organizerName | filterEmpty"
              />
              <description-item
                :key="'org-addr-' + index"
                :label="$t('label.exhibition.detail.organizerAddress')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="organizer.organizerAddress | filterEmpty"
              />
              <description-item
                :key="'org-contact-' + index"
                :label="$t('label.exhibition.detail.organizerContact')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="organizer.organizerContacts | filterEmpty"
              />
            </template>
          </template>
          <description-item
            v-else
            :label="$t('label.exhibition.detail.organizerName')"
            :span="24"
            value="--"
          />
        </description>
        <div class="pbr-title mt15 mb15">{{ $t('label.exhibition.detail.description') }}</div>
        <div class="exhibition-desc">{{ info.desc | filterSymbol }}</div>

        <div class="project-disclaimer">
          <div class="project-disclaimer-title">{{ $t('label.project.detail.disclaimer') }}</div>
          <div class="project-disclaimer-content">{{ $t('label.project.detail.disclaimerContent') }}</div>
        </div>
        <div class="project-detail-contact-hint">
          {{ $t('label.project.detail.contactHint') }}
        </div>
      </div>

     
    </div>
    <div class="wrap-box-right">
      <div>
        <div class="pbr-title">
          {{ $t('label.project.detail.relatedBusinessOpportunities') }}
        </div>
        <normal-list
          :data="businessModels"
          :page-size="10"
          goto="pbrBusinessDetail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NormalList from '../index/NormalList.vue'
import Description from '../components/ElDescription.vue'
import DescriptionItem from '../components/ElDescriptionItem.vue'

const pickFirst = (obj, keys) => {
  if (!obj) return ''
  for (let i = 0; i < keys.length; i++) {
    const val = obj[keys[i]]
    if (val !== undefined && val !== null && String(val).trim() !== '') {
      return val
    }
  }
  return ''
}


const formatDateRange = (start, end) => {
  const s = start ? String(start).trim() : ''
  const e = end ? String(end).trim() : ''
  if (s && e) return `${s} - ${e}`
  return s || e || ''
}

export default {
  name: 'pbrExhibitionDetail',
  components: {
    NormalList,
    Description,
    DescriptionItem
  },
  data() {
    return {
      loading: false,
      info: {},
      venueList: [],
      organizerList: [],
      businessModels: []
    }
  },
  computed: {
    holdDateText() {
      return formatDateRange(this.info.startDate, this.info.endDate)
    },
    nextHoldDateText() {
      return formatDateRange(this.info.nextStartDate, this.info.nextEndDate)
    }
  },
  activated() {
    this.resetData()
    if (this.$route.query.key) {
      this.fetchExhibitionDetail()
      this.fetchExhibitionRinfos()
    }
  },
  methods: {
    resetData() {
      this.info = {}
      this.venueList = []
      this.organizerList = []
      this.businessModels = []
    },
    getRequestParams() {
      const locale = localStorage.getItem('locale')
      return {
        id: this.$route.query.key,
        lang: this.$route.query.lang || (locale === 'en' ? 'en' : 'cn'),
        from: 'cn'
      }
    },
    mapDetailModel(raw) {
      const model = raw || {}
      return {
        title: pickFirst(model, ['title', 'exhibitionName', 'name']),
        country: pickFirst(model, ['country', 'countryName']),
        city: pickFirst(model, ['city', 'cityName']),
        industry: pickFirst(model, ['industry', 'industryName']),
          relatedFields: model.relatedFields || '',
        audience: model.audience || '',
        holdCycle:
          model.cycleNum != null &&
          model.cycleUnit &&
          model.cycleTimes != null
            ? `${model.cycleNum}${model.cycleUnit}${model.cycleTimes}${this.$t('label.exhibition.cycleTimes')}`
            : '',
        startDate: pickFirst(model, ['startDate', 'holdStartDate']),
        endDate: pickFirst(model, ['endDate', 'holdEndDate']),
        nextStartDate: pickFirst(model, ['nextStartDate', 'nextHoldStartDate']),
        nextEndDate: pickFirst(model, ['nextEndDate', 'nextHoldEndDate']),
        desc: pickFirst(model, [
          'desc',
          'description',
          'content',
          'exhibitionDesc'
        ])
      }
    },
    applyDetailResult(result) {
      const detail = result.infoModel || result.exhibitionModel || result
      this.info = this.mapDetailModel(detail)
      this.venueList = detail.venues || []
      this.organizerList = detail.organizers || []
    },
    fetchExhibitionDetail() {
      this.loading = true
      this.$pbrApis
        .fetchExhibitionDetail(this.getRequestParams())
        .then(res => {
          if (!res) return
          if (res.code === 200 || res.success) {
            this.applyDetailResult(res.result || {})
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchExhibitionRinfos() {
      this.$pbrApis
        .fetchExhibitionRiskInfos(this.getRequestParams())
        .then(res => {
          if (!res) return
          if (res.code === 200 || res.success) {
            const result = res.result || {}
            this.businessModels =
              result.businessModels ||
              result.businessList ||
              result.models ||
              []
          }
        })
    }
  },
  filters: {
    filterEmpty(value) {
      if (value === undefined || value === null || String(value).length === 0) {
        return '--'
      }
      return value
    },
    filterSymbol(value) {
      if (value && value.length > 0) {
        return value
          .replace(/[?？]{2,}/g, '')
          .replace(/\n+/g, '\n')
          .replace(/@Project_Content@/g, '')
      }
      return '--'
    }
  }
}
</script>

<style scoped>

.exhibition-desc {
  white-space: pre-wrap;
  line-height: 1.5;
  font-size: 14px;
  border: 1px solid #eee;
    border-radius: 4px;
    padding: 10px 15px;
    background-color: #fafafa;
}
</style>
